/**
 * A people field may be a 'responsibility' in the workflow of the card. You can create multiple
 * assignee type fields, that can be currently the active owners of the card, or people
 * who had finished their work on the card.
 */
export enum PeopleRoleType {
    Active = 'active',
    Next = 'next',
    Done = 'done',
}

export interface IRoleData {
    roleType?: PeopleRoleType;
    dueDate?: number;
    isComplete?: boolean;
    taskId?: string;
    estimate?: number;
    effort?: number;
}